// 📁 components/categoria/DetailsModal.js - CON EXPORTACIÓN
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  TablePagination,
  Paper,
  Avatar,
  Chip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CategoryIconBox, StyledButton, theme } from "../../styles/CategoriaStyles";
import { getCategoriaIcon } from "./IconHelper";
import { getNombreAsociacion, getNombreDepartamento } from "../../utils/categoriaHelpers";
//fghhdfhdf
const DetailsModal = ({ 
  open, 
  onClose, 
  categoria, 
  representantes = [], 
  asociaciones = [], 
  departamentos = [],
  extraActions = null // ← NUEVO: Para botones adicionales como exportación
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  if (!categoria) return null;

  // Filtrar representantes de esta categoría
  const representantesCategoria = representantes.filter(
    (rep) => rep.categorias && rep.categorias.some((cat) => cat.Id === categoria.Id && cat.Estado !== 'Inactivo')
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClose = () => {
    onClose();
    // Reset pagination when closing
    setPage(0);
  };

  // Calcular datos paginados
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedRepresentantes = representantesCategoria.slice(startIndex, endIndex);

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      fullWidth 
      maxWidth="lg" 
      PaperProps={{ 
        sx: { 
          borderRadius: "16px", 
          maxHeight: "90vh" 
        } 
      }}
    >
      {/* Dialog Title */}
      <DialogTitle sx={{ 
        backgroundColor: theme.palette.primary.main, 
        color: theme.palette.primary.contrastText, 
        p: 3, 
        fontWeight: 700 
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <CategoryIconBox sx={{ 
            backgroundColor: "rgba(255,248,240,0.2)", 
            border: "none" 
          }}>
            {getCategoriaIcon(categoria.Descripcion, 32, theme)}
          </CategoryIconBox>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {categoria.Descripcion}
            </Typography>
            <Typography variant="body2" sx={{ 
              color: "rgba(255,248,240,0.8)" 
            }}>
              {representantesCategoria.length} representantes
            </Typography>
          </Box>
          
          {/* Botón de Exportación en el Header */}
          {extraActions && (
            <Box sx={{ mr: 2 }}>
              {extraActions}
            </Box>
          )}
          
          <IconButton 
            onClick={handleClose} 
            sx={{ 
              color: "white" 
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent sx={{ p: 4 }}>
        {representantesCategoria.length > 0 ? (
          <>
            <TableContainer 
              component={Paper} 
              elevation={0} 
              sx={{ 
                border: `1px solid ${theme.palette.border.light}`,
                borderRadius: "12px"
              }}
            >
              <Table>
                <TableHead sx={{ 
                  backgroundColor: theme.palette.background.card 
                }}>
                  <TableRow>
                    <TableCell sx={{ 
                      color: theme.palette.text.secondary, 
                      fontWeight: 700, 
                      textAlign: "center", 
                      py: 2 
                    }}>
                      Foto
                    </TableCell>
                    <TableCell sx={{ 
                      color: theme.palette.text.secondary, 
                      fontWeight: 700, 
                      textAlign: "center", 
                      py: 2 
                    }}>
                      Nombre
                    </TableCell>
                    <TableCell sx={{ 
                      color: theme.palette.text.secondary, 
                      fontWeight: 700, 
                      textAlign: "center", 
                      py: 2,
                      display: { xs: "none", sm: "table-cell" }
                    }}>
                      DNI
                    </TableCell>
                    <TableCell sx={{ 
                      color: theme.palette.text.secondary, 
                      fontWeight: 700, 
                      textAlign: "center", 
                      py: 2 
                    }}>
                      Cargo
                    </TableCell>
                    <TableCell sx={{ 
                      color: theme.palette.text.secondary, 
                      fontWeight: 700, 
                      textAlign: "center", 
                      py: 2,
                      display: { xs: "none", md: "table-cell" }
                    }}>
                      Asociación
                    </TableCell>
                    <TableCell sx={{ 
                      color: theme.palette.text.secondary, 
                      fontWeight: 700, 
                      textAlign: "center", 
                      py: 2,
                      display: { xs: "none", lg: "table-cell" }
                    }}>
                      Departamento
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedRepresentantes.map((representante, idx) => {
                    const categoriaRep = representante.categorias.find(
                      (cat) => cat.Id === categoria.Id && cat.Estado !== 'Inactivo'
                    );
                    
                    return (
                      <TableRow 
                        key={`${representante.cod_representante}-${idx}`} 
                        sx={{ 
                          "&:nth-of-type(odd)": { 
                            backgroundColor: theme.palette.background.paper 
                          },
                          "&:hover": {
                            backgroundColor: "rgba(139, 90, 43, 0.05)"
                          }
                        }}
                      >
                        <TableCell sx={{ textAlign: "center", py: 2 }}>
                          <Avatar 
                            src={representante.fotografia || ""} 
                            sx={{ 
                              width: 40, 
                              height: 40, 
                              mx: "auto", 
                              border: `2px solid ${theme.palette.primary.main}` 
                            }}
                          >
                            {representante.nombre_representante?.charAt(0) || "R"}
                          </Avatar>
                        </TableCell>
                        <TableCell sx={{ 
                          fontWeight: 600, 
                          textAlign: "center", 
                          py: 2 
                        }}>
                          {representante.nombre_representante || "Sin nombre"}
                        </TableCell>
                        <TableCell sx={{ 
                          textAlign: "center", 
                          py: 2,
                          display: { xs: "none", sm: "table-cell" }
                        }}>
                          {representante.dni || "Sin DNI"}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center", py: 2 }}>
                          <Chip 
                            label={categoriaRep?.Cargo || "Sin cargo"} 
                            size="small" 
                            sx={{ 
                              backgroundColor: theme.palette.accent.light, 
                              color: theme.palette.primary.main,
                              fontWeight: 600
                            }} 
                          />
                        </TableCell>
                        <TableCell sx={{ 
                          textAlign: "center", 
                          py: 2,
                          display: { xs: "none", md: "table-cell" }
                        }}>
                          {getNombreAsociacion(asociaciones, representante.cod_asociacion)}
                        </TableCell>
                        <TableCell sx={{ 
                          textAlign: "center", 
                          py: 2,
                          display: { xs: "none", lg: "table-cell" }
                        }}>
                          {getNombreDepartamento(departamentos, representante.cod_depto)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            <TablePagination
              component="div"
              count={representantesCategoria.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Filas por página:"
              labelDisplayedRows={({ from, to, count }) => 
                `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
              }
              sx={{ 
                borderTop: `1px solid ${theme.palette.border.light}`, 
                mt: 2 
              }}
            />
          </>
        ) : (
          // Empty State
          <Box sx={{ textAlign: "center", py: 6 }}>
            <Typography variant="h6" sx={{ 
              color: theme.palette.text.secondary, 
              mb: 2 
            }}>
              No hay representantes en esta categoría
            </Typography>
            <Typography variant="body2" sx={{ 
              color: theme.palette.text.secondary 
            }}>
              Esta categoría no tiene representantes asignados actualmente.
            </Typography>
          </Box>
        )}
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions sx={{ p: 3, justifyContent: "space-between" }}>
        {/* Botón de exportación adicional en el footer (opcional) */}
        <Box>
          {extraActions && representantesCategoria.length > 0 && (
            <Box sx={{ display: { xs: "block", md: "none" } }}>
              {/* Mostrar botón en mobile si no se ve en el header */}
              {extraActions}
            </Box>
          )}
        </Box>
        
        <StyledButton onClick={handleClose} variant="contained">
          Cerrar
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
};

export default DetailsModal;